export const calculateCoursesTotalPrice = (data, currentCurrency) => {
  let val = 0;

  data.forEach((dt) => {
    val += (currentCurrency === 'IQD' ? dt.iqd : Number(dt.price)) || 0;
  });
  return val;
};
